import styled, { css } from 'styled-components'
export const MenuStyle: any = {
  left: '10',
  top: '10',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  borderRadius: '10px',
  boxShadow: '0px 4px 30px rgba(0, 0, 0, 0.1)',
  background: '#E0E0E0',
  padding: '15px 14px',
  fontSize: '50%',
  position: 'absolute',
  heightMax: '50%',
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '17px',
  gap: '11px',
  overflow: 'auto',
  zIndex: '100'
}
export const WrapperAutocomplete: any = {
  width: '100%'
}
export const MenuItemStyle = {
  fontFamily: 'Montserrat',
  fontStyle: 'normal',
  fontWeight: '400',
  fontSize: '17px',
  lineHeight: '17px',
  color: '#000000'
}
export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    input {
      border: 1px solid ${theme.colors.lightGray};
      display: block;
      width: 100%;
      height: 48px;
      font-size: 1rem;
      padding: 0.6rem;
      border-radius: ${theme.border.smallRadius};
      background: ${theme.colors.xxlightGray};
      transition: 0.2s;
      appearance: none;
      cursor: pointer;

      &:hover {
        outline: none;
        border-color: ${theme.colors.secondary};
        box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
      }
    }

    label {
      display: block;
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
      line-height: 1;
      margin-top: 1rem;
      margin-left: 6px;
      padding-bottom: 0.3rem;
      color: ${theme.colors.white};
      position: relative;

      &::after {
        content: '';
        position: absolute;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid ${theme.colors.darkGray};
        border-radius: 6px;
        font-size: 2px;
        margin-left: 15px;
        right: 18px;
        top: 40px;
        pointer-events: none;
      }
    }
  `}
`
